import React, { useContext } from 'react';
import Bucket from '../../../../../Assets/Lens/Bucket.svg';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { clearImages, closeModal, setCarouselMenu, setImages, toggleTagList } from '../../../../../Features/lensSlice';
import { ImageContext } from '../../../../../Context/ImagesContext';

function MultipleImagesPreview() {
    const dispatch = useDispatch();

    const images = useSelector((state) => state.lens.media.images);

    const { imagesList, setImagesList } = useContext(ImageContext);

    const handleCloseModal = () => {
        dispatch(closeModal());
        dispatch(clearImages());
        setImagesList([]);
        dispatch(toggleTagList());
    }

    const handleNext = () => {
        dispatch(setCarouselMenu('form'));
    }

    const deleteImage = (id) => {
        const filteredList = images.filter(image => image.id !== id);
        const filteredFilesList = imagesList.filter(image => image.id !== id);
        dispatch(setImages(filteredList));
        setImagesList(filteredFilesList);
    }

    return (
        <div className="w-2/5 relative flex flex-col h-full p-4">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Default Post</h1>

                <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <div className="overflow-y-scroll pb-16 no-scrollbar">
                <div className="flex items-center flex-wrap gap-2 mt-4">
                    {images.map(image => {
                        return (
                            <div key={image.id} className="relative w-[118px] h-[118px] rounded-lg overflow-hidden">
                                <img className='w-full h-full object-cover' src={image.url} alt="" />
                            
                                <button onClick={() => deleteImage(image.id)} className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center rounded-full bg-[#EF4444]">
                                    <div className="w-[18px] h-[18px] flex items-center justify-center">
                                        <img src={Bucket} alt="" />
                                    </div>
                                </button>
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className="absolute bottom-0 left-0 w-full px-4 py-3 bg-[#FFFFFF] border-t border-[#EAEAEA]">
                <button onClick={handleNext} className='w-full px-4 py-[6px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-[14px] leading-[26px] text-buttonText'>Next</button>
            </div>
        </div>
    );
}

export default MultipleImagesPreview;
